/**
 * @generated SignedSource<<d752e21d087eb28a8f67234e78fd2410>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type ShipmentType = "EXTERNALLY_ARRANGED" | "FIRSTDIBS_FACILITATED" | "LOCAL_PICKUP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type shippingTrackingDetails_transaction$data = {
  readonly currentShipmentQuote: {
    readonly handlingTime: {
      readonly displayValue: string | null;
    } | null;
    readonly serviceMethod: {
      readonly describeRange: string | null;
    } | null;
  } | null;
  readonly leadTime: {
    readonly hasLeadTime: boolean | null;
  } | null;
  readonly pendingShipmentChangeReview: {
    readonly shipment: {
      readonly collectionTime: {
        readonly displayValue: string | null;
      } | null;
      readonly handlingTime: {
        readonly displayValue: string | null;
      } | null;
      readonly serviceMethod: {
        readonly describeRange: string | null;
      } | null;
      readonly shipmentType: ShipmentType | null;
    } | null;
    readonly shipmentQuote: {
      readonly handlingTime: {
        readonly displayValue: string | null;
      } | null;
      readonly serviceMethod: {
        readonly describeRange: string | null;
      } | null;
    } | null;
  } | null;
  readonly shipment: {
    readonly collectionTime: {
      readonly displayValue: string | null;
    } | null;
    readonly deliveryDateRangeDisplay: string | null;
    readonly estimatedShippingDate: string | null;
    readonly handlingTime: {
      readonly displayValue: string | null;
    } | null;
    readonly leadTimeMax: number | null;
    readonly leadTimeMin: number | null;
    readonly serviceMethod: {
      readonly describeRange: string | null;
    } | null;
  } | null;
  readonly sku: {
    readonly isAvailableNow: boolean | null;
    readonly leadTime: string | null;
  } | null;
  readonly " $fragmentType": "shippingTrackingDetails_transaction";
};
export type shippingTrackingDetails_transaction$key = {
  readonly " $data"?: shippingTrackingDetails_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"shippingTrackingDetails_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "shippingTrackingDetails_transaction"
};

(node as any).hash = "983553de58295506f3d2f8b6d0519e41";

export default node;
